'use client'

import React from 'react'
import { Root, Trigger, Content, Arrow, Portal } from '@radix-ui/react-tooltip'

import { arrowStyles, tipStyles } from './styles'
import { TooltipProps, Side } from './Tooltip.types'

export const Tooltip = ({
  className = '',
  children,
  content,
  testId,
  open,
  onOpenChange,
  addButtonWrapper = true,
  triggerClassName = '',
  side = Side.TOP,
}: TooltipProps) => {
  return (
    <Root open={open} onOpenChange={onOpenChange}>
      {/* When asChild is true, Radix moves the props and behavior into the children itself
          This is so a tooltip-wrapped button doesn't become a SH button in a Radix button */}
      <Trigger
        asChild={!addButtonWrapper}
        // pointer-events-auto is when the tooltip has a parent with [&>*]:pointer-events-none for heap tracking
        className={`${triggerClassName} text-left pointer-events-auto`}
        data-testid={testId}
      >
        {children}
      </Trigger>
      <Portal>
        <Content
          className={`${className} ${tipStyles({
            component: 'tooltip',
          })}`}
          collisionPadding={8}
          sideOffset={8}
          side={side}
        >
          {/* The extra div insures the last child of the content is treated as the
            last child (ex: p:last:mb-0). Without it, the tooltip's arrow is the last
            child */}
          <div>{content}</div>
          <Arrow
            className={arrowStyles}
            width={8}
            height={4}
            // 8px padding goes on the right and left of the arrow.
            // It makes it so the arrow is not touching the tip's border radius
            offset={8}
          />
        </Content>
      </Portal>
    </Root>
  )
}
